const validStateMachine = (dirty: boolean, invalid: boolean) => {
  return dirty ? invalid : false;
};

export { validStateMachine };



// WEBPACK FOOTER //
// ./src/tools/validators/validStateMachine.ts